import { useQuery } from '@tanstack/react-query';

import { useContentTypeId } from '@/features/custom-fields';

import * as api from './api';

export const auditKeys = {
  all: ['audit'] as const,
  timeline: (entity: string, entityId: string | number) =>
    [...auditKeys.all, 'timeline', entity, String(entityId)] as const,
};

/**
 * Compose: resolve the ContentType for `entity` (model label like
 * `"crm.deal"`), then fetch the audit timeline keyed by (CT id, object_id).
 * The list query stays disabled until the CT id is in cache.
 */
export function useAuditTimeline(entity: string, entityId: string | number) {
  const ct = useContentTypeId(entity);
  const ctId = ct.data?.id;

  const list = useQuery({
    queryKey: auditKeys.timeline(entity, entityId),
    queryFn: () => api.listAuditTimeline({ contentTypeId: ctId!, entityId }),
    enabled: Boolean(ctId && entityId),
  });

  return {
    ...list,
    // Surface a unified "loading" flag so the panel can show one skeleton
    // for both the CT lookup and the actual list fetch.
    isPending: ct.isPending || (Boolean(ctId) && list.isPending),
    isError: ct.isError || list.isError,
  };
}
